import { Box, Text } from 'grommet';
import { Gremlin } from 'grommet-icons';
import { colors } from 'modules/root/theme';
import React from 'react';

interface HighlightProps {
  message: string;
  primary?: boolean;
  warning?: boolean;
  danger?: boolean;
  success?: boolean;
  info?: boolean;
}

const Highlight = ({
  message,
  primary,
  warning,
  success,
  danger,
  info,
}: HighlightProps) => {
  const { background, color } =
    (danger && colors.danger) ||
    (info && colors.info) ||
    (warning && colors.warning) ||
    (primary && colors.primary) ||
    (success && colors.success) ||
    colors.primary;

  return (
    <Box
      background={background}
      fill="horizontal"
      direction="row"
      justify="evenly"
      pad="small"
      round="small"
    >
      <Gremlin color={color} size="medium" />
      <Text color={color}>{message}</Text>
    </Box>
  );
};

export default Highlight;
